// import { useRef, useState } from 'react';
// import '../pages/AdminPanel.css';
// import Footer from './Footer';
// import Header from './Header';
// import { FiChevronDown, FiMoreVertical } from 'react-icons/fi';
// import { DropdownMenu, DropdownMenuItem } from '../components/ui/dropdown-menu';
// import { FaFilePdf, FaFileImage, FaFileWord, FaFileExcel, FaFileAlt } from "react-icons/fa";

// function AdminPanel({ username, onSignOut }) {
//     const fileInputRef = useRef(null);
//     const [file, setFile] = useState([]);
//     const [previewURL, setPreviewURL] = useState("");
//     const handleImageClick = () => {
//         fileInputRef.current.click();
//     };
//     const handleFileChange = (event) => {
//         const selectedFile = event.target.files[0];
//         if (!selectedFile) return;

//         setFile(selectedFile);

//         if (selectedFile.type.startsWith("image/")) {
//             const imageURL = URL.createObjectURL(selectedFile);
//             setPreviewURL(imageURL);
//         } else {
//             setPreviewURL(""); // reset if not image
//         }
//     };
//     const excelMimeTypes = [
//         "application/vnd.ms-excel",
//         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//         "text/csv",
//         "application/csv"
//     ];
//     const renderFileIcon = () => {
//         if (!file) return null;

//         const type = file.type;

//         if (type === "application/pdf") return <FaFilePdf className="text-red-600 text-3xl" />;
//         if (type.startsWith("image/")) return <FaFileImage className="text-blue-500 text-3xl" />;
//         if (type.includes("word")) return <FaFileWord className="text-blue-600 text-3xl" />;
//         if (excelMimeTypes.includes(type)) {
//             return <FaFileExcel className="text-[#21A366] text-3xl" />;
//         }
//         if (type.includes("text")) return <FaFileAlt className="text-gray-600 text-3xl" />;
//         return <FaFileAlt className="text-gray-600 text-3xl" />;
//     };
//     const [showOptions, setShowOptions] = useState(false);
// const handleRemoveFile = () => {
//   setFile(null);
//   setShowOptions(false);
//   if (fileInputRef.current) {
//     fileInputRef.current.value = ""; // This clears the input
//   }
// };
//     return (
//         <div className="min-h-screen flex flex-col">
//             <Header username={username}
//                 onSignOut={onSignOut}
//             />
//             <div className="flex flex-grow w-full">
//                 <div className='col-12 text-center pt-5 '>
//                     <h1 className='adminHeading'>Upload and Manage Cost Estimation Files.</h1>
//                     <div className='mt-4'>
//                         <div className='mx-auto flex flex-row justify-center'>
//                             <div className='adminUpload w-[20%]'>
//                                 <span className='cursor-pointer' onClick={handleImageClick}>Upload File</span>
//                                 <input
//                                     type="file"
//                                     multiple
//                                     ref={fileInputRef}
//                                     onChange={handleFileChange}
//                                     className="hidden"
//                                 />
//                             </div>
//                             <div className='adminDropdown bg-[#7500c0] p-1 rounded-tr-[4px] rounded-br-[4px] '>
//                                 <DropdownMenu className="!pt-2" label={<FiChevronDown className="text-white" />}>
//                                     <DropdownMenuItem>
//                                         Option 1
//                                     </DropdownMenuItem>
//                                     <DropdownMenuItem>
//                                         Option 2
//                                     </DropdownMenuItem>
//                                     <DropdownMenuItem>
//                                         Option 3
//                                     </DropdownMenuItem>
//                                 </DropdownMenu>
//                             </div>
//                         </div>
//                         {file && (
//                             <div className="mt-4 text-sm text-gray-800 flex justify-center">
//                                 <div className="adminFile flex items-center">
//                                     {renderFileIcon()}
//                                     <span className="font-semibold">{file.name}</span>

//                                     <div className="relative">
//                                         <FiMoreVertical
//                                             className="cursor-pointer text-gray-600 hover:text-black"
//                                             onClick={() => setShowOptions(!showOptions)}
//                                         />
//                                         {showOptions && (
//                                             <div className="absolute right-0 top-6 bg-white border border-gray-300 shadow-md rounded-md z-10">
//                                                 <button
//                                                     className="block w-full px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
//                                                     onClick={handleRemoveFile}
//                                                 >
//                                                     Remove
//                                                 </button>
//                                             </div>
//                                         )}
//                                     </div>
//                                 </div>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//             <Footer className="mt-auto" />
//         </div>

//     )
// }
// export default AdminPanel;

import { useRef, useState } from 'react';
import '../pages/AdminPanel.css';
import Footer from './Footer';
import Header from './Header';
import { FiChevronDown, FiMoreVertical } from 'react-icons/fi';
import { DropdownMenu, DropdownMenuItem } from '../components/ui/dropdown-menu';
import { FaFilePdf, FaFileImage, FaFileWord, FaFileExcel, FaFileAlt } from "react-icons/fa";

function AdminPanel({ username, onSignOut }) {
    const fileInputRef = useRef(null);
    const [files, setFiles] = useState([]);
    const [previewURLs, setPreviewURLs] = useState({});
    const [showOptionsIndex, setShowOptionsIndex] = useState(null);

    const handleImageClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const newFiles = [...files];
        const newPreviews = { ...previewURLs };

        selectedFiles.forEach(file => {
            if (!newFiles.find(f => f.name === file.name && f.size === file.size)) {
                newFiles.push(file);
                if (file.type.startsWith("image/")) {
                    newPreviews[file.name] = URL.createObjectURL(file);
                }
            }
        });

        setFiles(newFiles);
        setPreviewURLs(newPreviews);

        // Reset input to allow re-uploading same file
        event.target.value = '';
    };

    const excelMimeTypes = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv",
        "application/csv"
    ];

    const renderFileIcon = (file) => {
        const type = file.type;
        if (type === "application/pdf") return <FaFilePdf className="text-red-600 text-3xl" />;
        if (type.startsWith("image/")) return <FaFileImage className="text-blue-500 text-3xl" />;
        if (type.includes("word")) return <FaFileWord className="text-blue-600 text-3xl" />;
        if (excelMimeTypes.includes(type)) return <FaFileExcel className="text-[#21A366] text-3xl" />;
        if (type.includes("text")) return <FaFileAlt className="text-gray-600 text-3xl" />;
        return <FaFileAlt className="text-gray-600 text-3xl" />;
    };

    const handleRemoveFile = (index) => {
        const newFiles = [...files];
        const removedFile = newFiles.splice(index, 1)[0];
        setFiles(newFiles);

        const newPreviews = { ...previewURLs };
        delete newPreviews[removedFile.name];
        setPreviewURLs(newPreviews);

        if (showOptionsIndex === index) {
            setShowOptionsIndex(null);
        }
    };

    return (
        <div className="min-h-screen flex flex-col">
            <Header username={username} onSignOut={onSignOut} />
            <div className="flex flex-grow w-full">
                <div className='col-12 text-center pt-5 '>
                    <h1 className='adminHeading'>Upload and Manage Cost Estimation Files.</h1>
                    <div className='mt-4'>
                        <div className='mx-auto flex flex-row justify-center'>
                            <div className='adminUpload w-[20%]'>
                                <span className='cursor-pointer' onClick={handleImageClick}>Upload File</span>
                                <input
                                    type="file"
                                    multiple
                                    ref={fileInputRef}
                                    onChange={handleFileChange}
                                    className="hidden"
                                />
                            </div>
                            <div className='adminDropdown bg-[#7500c0] p-1 rounded-tr-[4px] rounded-br-[4px] '>
                                <DropdownMenu className="!pt-2" label={<FiChevronDown className="text-white" />}>
                                    <DropdownMenuItem>Option 1</DropdownMenuItem>
                                    <DropdownMenuItem>Option 2</DropdownMenuItem>
                                    <DropdownMenuItem>Option 3</DropdownMenuItem>
                                </DropdownMenu>
                            </div>
                        </div>

                        {files.length > 0 && (
                            <div className="mt-6 flex justify-center gap-6 flex-wrap">
                                {files.map((file, index) => (
                                    <div key={file.name + index} className="adminFile justify-between flex items-center space-x-2 relative">
                                        {renderFileIcon(file)}
                                        <span className="font-semibold truncate max-w-[120px]">{file.name}</span>

                                        <div className="relative">
                                            <FiMoreVertical
                                                className="cursor-pointer text-gray-600 hover:text-black"
                                                onClick={() => setShowOptionsIndex(showOptionsIndex === index ? null : index)}
                                            />
                                            {showOptionsIndex === index && (
                                                <div className="absolute right-0 top-6 bg-white border border-gray-300 shadow-md rounded-md z-10">
                                                    <button
                                                        className="block w-full px-4 py-2 text-sm text-black-600 hover:bg-[#E6DCFF]"
                                                        onClick={() => handleRemoveFile(index)}
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer className="mt-auto" />
        </div>
    );
}

export default AdminPanel;
